import { render, staticRenderFns } from "./CouponUsage.vue?vue&type=template&id=12fef3fa&scoped=true&"
import script from "../../models/analysis/couponUsage.ts?vue&type=script&lang=ts&"
export * from "../../models/analysis/couponUsage.ts?vue&type=script&lang=ts&"
import style0 from "./CouponUsage.vue?vue&type=style&index=0&id=12fef3fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fef3fa",
  null
  
)

export default component.exports